import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppHotelModel } from '../views/models/app-hotel.model';
import { AWSS3Image } from '../views/models/AWSS3Image.model';
import { Router } from '@angular/router';
import { SednaSetupModel } from '../views/models/sedna-setup.model';
import { StatisticsModel } from '../views/models/statistics.model';
import { SednaTraceModel } from '../views/models/sedna-trace.model';
import { MenuTitleDescriptionModel } from '../views/models/menu-title-description.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppHotelService {
  modal_display$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  sliderImage_change$ = new BehaviorSubject<AWSS3Image[]>([]);
  statistisc_change$ = new BehaviorSubject<StatisticsModel>(new StatisticsModel());
  logoImage_change$ = new BehaviorSubject<AWSS3Image>(new AWSS3Image());
  darklogoImage_change$ = new BehaviorSubject<AWSS3Image>(new AWSS3Image());
  lightlogoImage_change$ = new BehaviorSubject<AWSS3Image>(new AWSS3Image());

  popupHotelId: number = null;

  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) {
  }

  getHotelInfoPromise(id: number): Promise<AppHotelModel> {
    return new Promise((resolve, reject) => {
      return this.httpClient.get<AppHotelModel>(environment.baseURL + '/v2/api' + '/app_hotel/' + id,
        {
          observe: 'body',
          responseType: 'json'
        }).subscribe((resp: AppHotelModel) => {
          resolve(resp);
        }, err => {
          reject(err);
        });
    })
  }

  getHotelInfo(id: number): Observable<AppHotelModel> {
    return this.httpClient.get<AppHotelModel>(environment.baseURL + '/v2/api' + '/app_hotel/' + id,
      {
        observe: 'body',
        responseType: 'json'
      });
  }

  getAppHotel(id: number): Promise<AppHotelModel> {
    return new Promise((resolve, reject) => {
      this.httpClient.get<AppHotelModel>(environment.baseURL + '/v2/api' + '/app_hotel/' + id).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  getRichData(id: string) {
    return this.httpClient.get('https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/' + id + '/RichMobileData.json?' + new Date().getTime());
  }

  getMobileData(id: string) {
    return this.httpClient.get('https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/' + id + '/MobileData.json?' + new Date().getTime());
  }

  putHotelInfo(data: AppHotelModel) {
    console.log(data);
    this.httpClient.put(environment.baseURL + '/v2/api' + '/app_hotel/' + data.id, data).subscribe(
      (resp) => {
        console.log(resp);
      },
      error => {
        console.log(error);
      },
    );

  }

  postSednaSetup(data: SednaSetupModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/sedna_setup', data).subscribe(
      (resp) => {
        console.log(resp);
      },
      error => {
        console.log(error);
      },
    );
  }

  getSednaSetup() {
    return this.httpClient.get<SednaSetupModel>(environment.baseURL + '/v2/api' + '/sedna_setup');
  }

  deleteHotel(id: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/app_hotel/' + id).subscribe(
      (res) => {
        this.router.navigateByUrl('/home').then(() => window.location.reload());
      },
      error => {
        console.log(error);
      }
    );
  }

  getHotelImage(id: number, directory: string) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/listbucketitems?bucketname=b1development&directory=icibotV2/' + id + '/' + directory).subscribe(
      (datas: AWSS3Image[]) => {
        if (datas) {
          datas.forEach(x => x.url = x.url + '?' + (new Date()).getTime());
          // @ts-ignore
          datas.sort((a, b) => new Date(a.last_modified) - new Date(b.last_modified));
          if (directory == 'Slider') {
            this.sliderImage_change$.next(datas);
          }
          if (directory == 'DarkLogo') {
            this.darklogoImage_change$.next(datas[0]);
          }
          if (directory == 'LightLogo') {
            this.lightlogoImage_change$.next(datas[0]);
          }
          if (directory == 'Logo') {
            this.logoImage_change$.next(datas[0]);
          }
        }

      },
      error => {
        console.log(error);
      },
    );
  }

  getStatistics(id: number, interval: string) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/hotel_statistics/' + id + '/' + interval).subscribe((data: StatisticsModel) => {
      this.statistisc_change$.next(data);
    });
  }

  postSednaTraceMap() {
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/recreate_sedna_trace_map_setup', 1);
  }

  getSednaTraceMaps() {
    return this.httpClient.get<SednaTraceModel[]>(environment.baseURL + '/v2/api' + '/sedna_trace_maps');
  }

  getTraceTitleDescription() {
    return this.httpClient.get<MenuTitleDescriptionModel[]>(environment.baseURL + '/v2/api' + '/trace_title_description');
  }

  putTraceTitleDescription(data: SednaTraceModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/sedna_trace_map', data).subscribe();
  }
}
